import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { shapes } from '@unite-us/client-utils';
import { Spinner } from 'common/spinners';
import { DynamicTable } from 'common/tables';
import firstLine from 'common/utils/firstLine';
import CaseRowIcon from 'src/components/Dashboard/components/Cases/CaseRowIcon';
import _ from 'lodash';
import { showFacesheetCasesTableDescription } from 'common/utils/FeatureFlags/flags';
import {
  networkColumn,
  clientNameColumn,
  serviceTypeColumn,
} from '../../utils/columnConfigs/baseColumns';
import FilterBar from '../FilterBar';

export function OONCasesIndex(props) {
  const {
    data,
    filters,
    isCaseMgmtProvider,
    isCC,
    isFetching,
    isSuperNetwork,
    onCellClick,
    onFiltersChange,
    onNextClick,
    onPrevClick,
    paging,
    fetchGroupsUsers,
    showDescription,
    sortConfig,
    setSort,
  } = props;

  const onSortColumn = (column, sortDirection) => {
    if (sortConfig) {
      sortConfig(column, sortDirection);
    }
  };

  const getColumns = () => {
    const descColumn = {
      label: 'Description',
      formatData: (item) => firstLine(item.description),
      className: 'truncate',
    };

    const baseColumns = [
      {
        label: 'Primary Worker',
        sortColumn: 'primary_worker.full_name',
      },
      ...(isCC ? [networkColumn(isSuperNetwork, 'network.name')] : []),
      clientNameColumn(setSort, onSortColumn),
      ...(showDescription ? [descColumn] : []),
      serviceTypeColumn(),
      {
        label: 'Date Opened',
        sortColumn: 'opened_date',
        sortBy: setSort?.sidx,
        sortDirection: setSort?.sord,
        setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
        type: 'date',
      },
      {
        label: 'Last Updated',
        sortColumn: 'updated_at',
        sortBy: setSort?.sidx,
        sortDirection: setSort?.sord,
        setSort: ({ sortBy, sortDirection }) => onSortColumn(sortBy, sortDirection),
        type: 'date',
      },
    ];
    return _.compact(baseColumns);
  };

  return (
    <div>
      <FilterBar
        filters={filters}
        onFiltersChange={onFiltersChange}
        paging={paging}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        isFetching={isFetching && !_.isEmpty(data)}
        asyncSearch={fetchGroupsUsers}
      />
      <div className="dashboard-inner-content">
        {
          (isFetching && _.isEmpty(data)) ?
            <Spinner /> : (
              <DynamicTable
                caption="Open out-of-network cases"
                id="open-oon-cases-table"
                dataSet={data}
                onCellClick={onCellClick}
                columnLabels={getColumns()}
                rowIcon={(serviceCase) => (
                  <CaseRowIcon
                    isCaseMgmtProvider={isCaseMgmtProvider}
                    serviceCase={serviceCase}
                  />
                )}
                emptyMessage="There are no open cases."
              />
            )
        }
      </div>
    </div>
  );
}

OONCasesIndex.propTypes = {
  data: PropTypes.array.isRequired,
  filters: PropTypes.array,
  isCaseMgmtProvider: PropTypes.bool,
  isCC: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isSuperNetwork: PropTypes.bool,
  onCellClick: PropTypes.func.isRequired,
  onFiltersChange: PropTypes.func,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  paging: shapes.paging,
  fetchGroupsUsers: PropTypes.func.isRequired,
  showDescription: PropTypes.bool,
  sortConfig: PropTypes.func,
  setSort: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    showDescription: showFacesheetCasesTableDescription(state),
  };
}

export default connect(mapStateToProps)(OONCasesIndex);
